import React, { useEffect, useContext } from "react";
import { Link as DomLink } from "react-router-dom";
import { Mobile, Default } from "../../utils/deviceHelpers";
import Container from "@mui/material/Container";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import DeleteIcon from "@mui/icons-material/Delete";
import { CartContext } from "../../utils/stateHandlers/contexts";
import { api, storage } from "../../utils";
import formatting from "../../utils/formatHelpers";
import _ from "lodash";
import parse from "html-react-parser";
import Divider from "@mui/material/Divider";

export default function Cart(props) {
  const { cartState, cartDispatch } = useContext(CartContext);
  const { cart } = cartState;
  const cartId =
    storage.getStorageItem("cartId") !== "null"
      ? storage.getStorageItem("cartId")
      : JSON.parse(storage.getStorageItem("cartId"));
  const subtotal = _.sumBy(cart, function (item) {
    return _.toNumber(item.invoices[0].total);
  });

  const MobileLineItem = (lineItem) => (
    <Stack spacing={1}>
      {lineItem.invoices.map((invoice) => (
        <>
          <Typography
            variant="headerFont"
            sx={{
              backgroundColor: "#f0f0f0",
              padding: "0.5rem",
            }}
          >
            {parse(invoice.specification)}
          </Typography>
          <Typography variant="headerFont">
            Ship Date: {lineItem.ship_info.ship_date}
          </Typography>
          <Typography variant="cellFont">
            Material: {invoice.material}
          </Typography>
          <Typography variant="cellFont">
            Quantity: {formatting["removeSpace"](invoice.quantity)}
          </Typography>
          <Typography variant="cellFont">
            Weight: {formatting["removeSpace"](invoice.weight)}
          </Typography>
          <Typography variant="cellFont">
            Unit Rate: {formatting["price2"](invoice.unit_price)}
          </Typography>
          <Typography variant="cellFont">
            Material Rate: {formatting["price2"](invoice.material_price)}
          </Typography>
          <Typography variant="cellFont">
            Labor/Unit: {formatting["price2"](invoice.labor_per_unit)}
          </Typography>
          <Typography variant="cellFont">
            Total Material: {formatting["price2"](invoice.total_material)}
          </Typography>
          <Typography variant="cellFont">
            Total Labor: {formatting["price2"](invoice.total_labor)}
          </Typography>
          <Typography variant="headerFont">
            Item Total: {formatting["price2"](invoice.total)}
            <IconButton
              color="error"
              className="float-right"
              onClick={() => deleteLineItem(lineItem)}
            >
              <DeleteIcon sx={{ verticalAlign: "middle" }} />
            </IconButton>
          </Typography>
        </>
      ))}
      <Divider orientation="horizontal" flexItem="true" />
    </Stack>
  );

  const SingleInvoiceLine = (lineItem) => (
    <>
      {lineItem.invoices.map((invoice) => (
        <TableRow key={invoice.specification}>
          <TableCell>
            <Typography variant="cellFont">
              {lineItem.ship_info.ship_date}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {parse(invoice.specification)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">{invoice.material}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {formatting["removeSpace"](invoice.quantity)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {formatting["removeSpace"](invoice.weight)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {invoice.unit_price === "0.00000"
                ? "---"
                : formatting["price2"](invoice.unit_price)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {invoice.material_price === "0.00000"
                ? "---"
                : formatting["price2"](invoice.material_price)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {invoice.labor_per_unit === "0.00000"
                ? "---"
                : formatting["price2"](invoice.labor_per_unit)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {invoice.total_material === "0.00000"
                ? "---"
                : formatting["price2"](invoice.total_material)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {invoice.total_labor === "0.00000"
                ? "---"
                : formatting["price2"](invoice.total_labor)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="headerFont">
              {invoice.total === "0.00000"
                ? "---"
                : formatting["price2"](invoice.total)}
            </Typography>
          </TableCell>
          <TableCell>
            <IconButton color="error" onClick={() => deleteLineItem(lineItem)}>
              <DeleteIcon sx={{ verticalAlign: "middle" }} />
            </IconButton>
          </TableCell>
        </TableRow>
      ))}
    </>
  );

  const MultiInvoiceLine = (lineItem) => {
    const bandLine = lineItem.invoices[0];
    const diamondLine = lineItem.invoices[1];
    const totalPrice = lineItem.invoices[2].total;
    return (
      <>
        <TableRow>
          <TableCell>
            <Typography variant="cellFont">
              {lineItem.ship_info.ship_date}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {parse(bandLine.specification)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">{bandLine.material}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {formatting["removeSpace"](bandLine.quantity)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {formatting["removeSpace"](bandLine.weight)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {bandLine.unit_price === "0.00000"
                ? "---"
                : formatting["price2"](bandLine.unit_price)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {bandLine.material_price === "0.00000"
                ? "---"
                : formatting["price2"](bandLine.material_price)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {bandLine.labor_per_unit === "0.00000"
                ? "---"
                : formatting["price2"](bandLine.labor_per_unit)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {bandLine.total_material === "0.00000"
                ? "---"
                : formatting["price2"](bandLine.total_material)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {bandLine.total_labor === "0.00000"
                ? "---"
                : formatting["price2"](bandLine.total_labor)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="headerFont">
              {totalPrice === "0.00000"
                ? "---"
                : formatting["price2"](totalPrice)}{" "}
            </Typography>
          </TableCell>
          <TableCell>
            <IconButton color="error" onClick={() => deleteLineItem(lineItem)}>
              <DeleteIcon sx={{ verticalAlign: "middle" }} />
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell></TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {parse(diamondLine.specification)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">{diamondLine.material}</Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {formatting["removeSpace"](diamondLine.quantity)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {formatting["removeSpace"](diamondLine.weight)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {diamondLine.unit_price === "0.00000"
                ? "---"
                : formatting["price2"](diamondLine.unit_price)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {diamondLine.material_price === "0.00000"
                ? "---"
                : formatting["price2"](diamondLine.material_price)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {diamondLine.labor_per_unit === "0.00000"
                ? "---"
                : formatting["price2"](diamondLine.labor_per_unit)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {diamondLine.total_material === "0.00000"
                ? "---"
                : formatting["price2"](diamondLine.total_material)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont">
              {diamondLine.total_labor === "0.00000"
                ? "---"
                : formatting["price2"](diamondLine.total_labor)}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="cellFont"> </Typography>
          </TableCell>
          <TableCell></TableCell>
        </TableRow>
      </>
    );
  };

  function deleteLineItem(lineItem) {
    const toDelete = {
      cart_id: storage.getStorageItem("cartId"),
      id: lineItem.id,
    };
    api.post("cart/remove", toDelete).then((res) => {
      cartDispatch({
        type: "updateCart",
        payload: {
          cart: res.data.items,
          cartCount: res.data.count,
        },
      });
    });
  }

  useEffect(() => {
    api.fetch("cart/check?cart_id=", cartId).then((response) => {
      cartDispatch({ type: "setCart", payload: response.data.items });
      cartDispatch({ type: "setCartCount", payload: response.data.count });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CartContext.Provider value={{ cartState, cartDispatch }}>
      <Container maxWidth="xl">
        <Mobile>
          <Stack spacing={3}>
            <Typography variant="h1">Shopping Cart</Typography>
            {cart && cart.length === 0 && (
              <Typography>Your cart is empty!</Typography>
            )}
            {cart && cart.length > 0 && (
              <>
                {cart && cart.map((lineItem) => MobileLineItem(lineItem))}
                <div style={{ marginRight: "9.5rem" }}>
                  <Typography
                    variant="cellFont"
                    className="float-right"
                    sx={{ fontWeight: "800" }}
                  >
                    Subtotal: {formatting["price2"](subtotal)}
                  </Typography>
                </div>
                <DomLink to={{ pathname: "/checkout" }}>
                  <Button variant="contained" color="success">
                    Checkout
                  </Button>
                </DomLink>
              </>
            )}
          </Stack>
        </Mobile>
        <Default>
          <Stack spacing={3}>
            <Typography variant="h1">Shopping Cart</Typography>
            {cart && cart.length === 0 && (
              <Typography>Your cart is empty!</Typography>
            )}
            {cart && cart.length > 0 && (
              <>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Typography variant="headerFont">Ship Date</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="headerFont">
                          Specifications
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="headerFont">Material</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="headerFont">Quantity</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="headerFont">Weight</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="headerFont">Unit Rate</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="headerFont">
                          Material Rate
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="headerFont">Labor/Unit</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="headerFont">
                          Total Material
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="headerFont">
                          Total Labor
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="headerFont">Total</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="headerFont">Actions</Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {cart &&
                    cart.map((lineItem) => (
                      <TableBody key={lineItem.id}>
                        {lineItem.invoices.length > 1
                          ? MultiInvoiceLine(lineItem)
                          : SingleInvoiceLine(lineItem)}
                      </TableBody>
                    ))}
                </Table>
                <div style={{ marginRight: "9.5rem" }}>
                  <Typography
                    variant="cellFont"
                    className="float-right"
                    sx={{ fontWeight: "800" }}
                  >
                    Subtotal: {formatting["price2"](subtotal)}
                  </Typography>
                </div>
                <div style={{ marginRight: "9.5rem" }}>
                  <DomLink to={{ pathname: "/checkout" }}>
                    <Button
                      variant="contained"
                      color="success"
                      className="float-right"
                    >
                      Checkout
                    </Button>
                  </DomLink>
                </div>
              </>
            )}
          </Stack>
        </Default>
      </Container>
    </CartContext.Provider>
  );
}
